import { ConsumerLoanProduct } from 'models/product.models';

export const isConsumerLoanProduct = (
  value: unknown,
): value is ConsumerLoanProduct => {
  return Object.values(ConsumerLoanProduct).includes(
    value as ConsumerLoanProduct,
  );
};
